import { BusinessInfo, ContactInfo } from '../types';

export const businessData: BusinessInfo = {
  "business_name": "Laxmi Tyres & Motors",
  "location": "Limbodi, Indore",
  "category": "Automobile Repair & Services",
  "price_note": "Prices are indicative and may vary depending on car model and condition.",
  "services": [
    {
      "id": "600083223",
      "service_name": "Car Wash Service",
      "starting_price": 250,
      "unit": "per service",
      "description": "Exterior washing, interior vacuuming, tyre cleaning, waxing, polishing and detailing to maintain hygiene and appearance."
    },
    {
      "id": "600083346",
      "service_name": "Car Denting and Painting Service",
      "starting_price": 1000,
      "unit": "per service",
      "description": "Complete dent repair and painting to restore vehicle body, color and finish."
    },
    {
      "id": "600083224",
      "service_name": "Car Battery Repair & Services",
      "starting_price": 300,
      "unit": "per service",
      "description": "Battery testing, charging, troubleshooting and replacement to ensure reliable vehicle starting."
    },
    {
      "id": "600083217",
      "service_name": "Car Mechanical Repairs",
      "starting_price": 499,
      "unit": "per service",
      "description": "Engine, transmission, brake and suspension diagnostics and mechanical repairs."
    },
    {
      "id": "600083221",
      "service_name": "Car AC Repair & Services",
      "starting_price": 1000,
      "unit": "per service",
      "description": "AC inspection, gas refill, compressor and condenser repairs for proper cooling."
    },
    {
      "id": "600083226",
      "service_name": "Car Clutch & Body Parts Services",
      "starting_price": 300,
      "unit": "per service",
      "description": "Clutch repair, replacement and body part repairs including dent and scratch fixing."
    },
    {
      "id": "600083219",
      "service_name": "Car Lights and Fittings",
      "starting_price": 300,
      "unit": "per service",
      "description": "Headlight, taillight, indicator and interior lighting installation and repair."
    },
    {
      "id": "600083218",
      "service_name": "Car Regular Services",
      "starting_price": 1000,
      "unit": "per service",
      "description": "Oil change, filter replacement, brake inspection and routine maintenance."
    },
    {
      "id": "600083225",
      "service_name": "Car Suspension & Fitment Services",
      "starting_price": 500,
      "unit": "per service",
      "description": "Suspension inspection, shock absorber repair, alignment and fitment."
    },
    {
      "id": "600083220",
      "service_name": "Car Tyre & Wheel Services",
      "starting_price": 300,
      "unit": "per service",
      "description": "Tyre fitting, balancing, rotation and wheel alignment."
    },
    {
      "id": "600083222",
      "service_name": "Car Polishing Services",
      "starting_price": 300,
      "unit": "per service",
      "description": "Paint polishing to remove scratches, swirl marks and restore shine."
    },
    {
      "id": "600083227",
      "service_name": "Car Inspections",
      "starting_price": 500,
      "unit": "per service",
      "description": "Complete vehicle inspection including brakes, tyres, lights and emissions."
    }
  ]
};

export const contactInfo: ContactInfo = {
  phone: "097552 65555",
  email: "info@laxmimotors.com",
  address: "Plot No 7, Khandwa Rd, opposite Sri Chaitanya techno academy, Shri Krishna Avenue, Limbodi, Indore, Madhya Pradesh 452001",
  hours: "Mon-Sat: 9:00 AM - 7:00 PM, Sun: 10:00 AM - 5:00 PM"
};

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    rating: 5,
    comment: "Excellent service! My car's denting work was done perfectly. Very professional team.",
    service: "Car Denting and Painting"
  },
  {
    id: 2,
    name: "Priya Sharma",
    rating: 5,
    comment: "Best car wash service in Indore. They take care of every detail. Highly recommended!",
    service: "Car Wash Service"
  },
  {
    id: 3,
    name: "Amit Patel",
    rating: 4,
    comment: "Quick and reliable AC repair service. Fixed my car's cooling issue in no time.",
    service: "Car AC Repair"
  },
  {
    id: 4,
    name: "Sunita Jain",
    rating: 5,
    comment: "Honest pricing and quality work. Been coming here for 3 years for regular servicing.",
    service: "Car Regular Services"
  }
];